/**
 * PrivacyARPrivacyTextView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PrivacyARPrivacyText
 */

import { usePrivacyARPrivacyTextLogic } from '@/hooks/traits/usePrivacyARPrivacyTextLogic';
import type { PrivacyARPrivacyTextConfig } from '@/hooks/traits/usePrivacyARPrivacyTextLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PrivacyARPrivacyView as PrivacyARPrivacyViewEntity } from '@app/shared';
import { Box } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { MarkdownContent } from '@almadar/ui/components';
import { Badge } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface PrivacyARPrivacyTextViewProps {
  config?: Partial<PrivacyARPrivacyTextConfig>;
}

export function PrivacyARPrivacyTextView({ config: propsConfig }: PrivacyARPrivacyTextViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePrivacyARPrivacyTextLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PrivacyARPrivacyView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PrivacyAR" trait="PrivacyARPrivacyText">
      {slotWriter['main'] === 'INIT' ? (<Box bg={(false) ? "muted" : "transparent"} dir="ltr" fullWidth={true} paddingY="xl"><Container padding="lg" maxWidth="md" size="md"><Stack gap="md" direction="vertical"><Badge variant="primary" label="" /><Typography size="3xl" variant="h1" content={renderPatternValue(__t("std-almadar-privacy:privacy.heading"))} weight="bold" className={((__t("std-almadar-privacy:privacy.heading") === "")) ? "hidden" : "tracking-tight text-balance"} /><Typography className={(true) ? "hidden" : ""} content="" color="muted" variant="caption" /><MarkdownContent direction="ltr" content={String(__t("std-almadar-privacy:privacy.body"))} /></Stack></Container></Box>) : null}
    </TraitScopeProvider>
  );
}

export default PrivacyARPrivacyTextView;
